import React from "react";

const validationMessage = (props) => {
  return (
    <div
      style={{ width: "1rem", height: "1rem" }}
      className={["spinner-border", "mr-1", "text-primary"].join(" ")}
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default validationMessage;
